// import { initEcho } from '@/core/echo'
import router from '@/core/routes';
//
// export const flash = ({ commit }, flash) => {
//   commit('setFlash', flash)
//
//   commit('setFlashShow', true)
//   setTimeout(() => commit('setFlashShow', false), 6000)
// }
//
// export const openConfirm = ({ commit }, confirm) => {
//   commit('setConfirm', confirm)
//
//   commit('setConfirmShow', true)
// }
//
// export const closeConfirm = ({ commit }) => {
//   commit('setConfirmShow', false)
// }
//
export const initUser = ({ dispatch }) => {
  if (router.currentRoute.name === 'login') {
    router.push({ name: 'dashboard:index' });
  }

  // initEcho()
};

export const cleanUpUser = ({ commit }) => {
  // commit('setLocations', [])
  // commit('setCurrentLocationId', null)
  // commit('setStations', [])

  // window.echo = null
};
